module.exports = __webpack_public_path__ + "static/media/human-advantage-vial.f25204fd.svg";